import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Router from 'vue-router'
import App from './App.vue'
import router from './router/index.js';

import './assets/css/main.css';
import './assets/css/theme.scss';
import './assets/css/aitit.css';

Vue.use(ElementUI);
Vue.config.productionTip = false
// Vue.prototype.API_BASE_URL = 'http://ai.aezhushou.com/api';
// Vue.prototype.API_BASE_URL = 'http://localhost:5170/api';
// new Vue({
//   render: h => h(App),
// }).$mount('#app')

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | DeepSeek跨境标题生成器`;  
  const lowerPath = to.path.toLowerCase();
  if (to.path !== lowerPath) {
    next(lowerPath);
  } else {
    next();
  }
});

// 全局捕获路由错误
router.onError((error) => {
  if (error.name !== 'NavigationDuplicated') {
    console.error('全局路由错误:', error);
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')